import { getConfig } from '@cian/config/browser';

import React from 'react';

import { CheckboxLabel } from '../../../components/CheckboxLabel';
import { TCoworkingOfferTypeList } from '../../../types/coworkingOfferType';
import { FCoworkingOfferType } from '../../../utils/category';

export const OFFER_TYPES_RENT_COWORKING: TCoworkingOfferTypeList = [
  [
    {
      label: 'Отдельный офис',
      value: FCoworkingOfferType.FlexibleOffice,
    },
    {
      label: (
        <CheckboxLabel
          label="Закреплённое рабочее место"
          postfixType="info"
          tooltipTitle="Этим столом будете пользоваться только вы"
        />
      ),
      value: FCoworkingOfferType.FixedWorkSpace,
    },
    {
      label: (
        <CheckboxLabel
          label="Незакреплённое рабочее место"
          postfixType="info"
          tooltipTitle="Любое доступное рабочее место в общей зоне"
        />
      ),
      value: FCoworkingOfferType.FreeWorkSpace,
    },
  ],
];

/**
 * @todo Удалить блок с RS
 * @description Данный функционал появился в задаче CD-96793, будет удалён в задаче CD-97047
 */
{
  let enabled: boolean | null = null;

  const setEnabledVariable = () => {
    if (enabled === null) {
      enabled = !!getConfig().get<boolean>('Coworking.Workplaces.Enabled');
    }
  };

  Object.defineProperties(OFFER_TYPES_RENT_COWORKING[0][1], {
    label: {
      get() {
        setEnabledVariable();

        if (enabled) {
          return (
            <CheckboxLabel
              label="Закреплённое рабочее место"
              postfixType="info"
              tooltipTitle="Этим столом будете пользоваться только вы"
            />
          );
        }

        return <CheckboxLabel label="Закреплённое рабочее место" postfixType="soon" />;
      },
    },
    disabled: {
      get() {
        setEnabledVariable();

        return !enabled;
      },
    },
  });

  Object.defineProperties(OFFER_TYPES_RENT_COWORKING[0][2], {
    label: {
      get() {
        setEnabledVariable();

        if (enabled) {
          return (
            <CheckboxLabel
              label="Незакреплённое рабочее место"
              postfixType="info"
              tooltipTitle="Любое доступное рабочее место в общей зоне"
            />
          );
        }

        return <CheckboxLabel label="Незакреплённое рабочее место" postfixType="soon" />;
      },
    },
    disabled: {
      get() {
        setEnabledVariable();

        return !enabled;
      },
    },
  });
}
